import { Location } from '../../dto/c4/location/index';
import { IS_NOT_EMPTY } from '../../utils/stringUtils/string-utils';
import { TruckSearchTable } from '../../searchTrucks/views';

export const LOCATION_PARSER = (location: Location): string => {
	let result = '';
	if (IS_NOT_EMPTY(location.city)) {
		result = location.city;
	}
	if (IS_NOT_EMPTY(location.state)) {
		result += (result.length > 0 ? ', ' : '') + location.state;
	}
	if (IS_NOT_EMPTY(location.zip) && !/\D/.test(location.zip)) {
		result += (result.length > 0 ? ', ' : '') + location.zip;
	}
	return result;
};

export const POPULATE_ORIGIN = (truck: TruckSearchTable, location: Location) => {
	truck.originCity = location.city;
	truck.originState = location.state;
};

export const POPULATE_DESTINATION = (truck: TruckSearchTable, location: Location) => {
	truck.destCity = location.city;
	truck.destState = location.state;
};

export const HQ_LOCATION_PARSER = (city: string, state: string): string => {
	let hqLocation = '';
	if (IS_NOT_EMPTY(city) || IS_NOT_EMPTY(state)) {
		if (IS_NOT_EMPTY(city) && IS_NOT_EMPTY(state)) {
			hqLocation = `${city} , ${state}`;
		} else if (IS_NOT_EMPTY(city)) {
			hqLocation = city;
		} else {
			hqLocation = state;
		}
	}
	return hqLocation;
};

export const LOCATION_PARSER_WITHOUT_ZIP = (location: Location): string => {
	let result = '';
	if (IS_NOT_EMPTY(location.city)) {
		result = location.city;
	}
	if (IS_NOT_EMPTY(location.state)) {
		result += (result.length > 0 ? ', ' : '') + location.state;
	}
	return result;
};

export const GET_CITY_STATE_FROM_LOCATION_STRING = (
	location: string
): { city: string; state: string } => {
	let result = { city: '', state: '' };
	if (IS_NOT_EMPTY(location)) {
		let stringSplit = location.split(',');
		result = {
			...result,
			city: IS_NOT_EMPTY(stringSplit[0]) ? stringSplit[0].trim() : '',
			state: IS_NOT_EMPTY(stringSplit[1]) ? stringSplit[1].trim() : '',
		};
	}
	return result;
};
